import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {BsModalRef} from 'ngx-bootstrap/modal';

@Component({
  selector: 'modal-confirm',
  templateUrl: './modal-confirm.component.html',
})
export class ModalConfirmComponent implements OnInit {

  id: string;
  form: FormGroup;

  constructor(public modalRef: BsModalRef) { }

  ngOnInit(): void {
    this.initForm();
  }


  hide() {
    this.modalRef.hide();
  }

  initForm() {
    this.form = new FormBuilder().group({
    });
  }

  confirm() {
    this.hide();
    // This method replacing by init Modal
  }

  cancel() {
    // This method replacing by init Modal
  }
}
